/* ===========================================================================
   ROVE NEXT — THE CART'S OWN QUANTITY CHECK. 25–26 September 2026.

   "I can edit any qty in the cart" — Sharon, and again after the PDP was
   fixed. The same rule as the PDP (assets/rn-pdp-qty.js): a number above what
   is really available is KEPT as typed, the stepper goes red, the line says
   what the real number is, and nothing is sent to the cart until it is
   lowered. Checkout is disabled while any line is in that state.

   WHY THE FIRST VERSION DID NOT WORK. It read window.RN_CART_STOCK, which is
   rendered once at page load from whatever was in the cart THEN. Anything
   added afterwards without a reload — the normal path, the drawer never
   reloads — had no numbers and so no cap at all. The numbers now sit on each
   line's own <cart-quantity-selector-component> (data-rn-stock,
   data-rn-po-remaining, data-rn-po-line; snippets/quantity-selector.liquid),
   and the drawer is re-rendered from the server after every change, so they
   are always current. RN_CART_STOCK / RN_NOTIFY remain as a fallback.

   TWO LINES, ONE VARIANT. A mixed order is added as two lines (sections/
   rn-buybox.liquid): an in-stock line and a pre-order line carrying
   _preorder_eta. They are capped differently:
     · in-stock line:  real stock, minus other in-stock lines of the variant
                       (raising it past that would label pre-order units as
                       shipping now)
     · pre-order line: the shipment allocation only (preorder.remaining),
                       minus other pre-order lines of the variant
   Other lines are counted at their SAVED quantity (the input's value
   attribute, as the server rendered it), not whatever is mid-edit.

   Untracked inventory counts as none on the shelf, so its line is capped at
   the pre-order allocation; with no allocation either, it is left uncapped —
   the same rule as the PDP. preorder.mode is never read.
   =========================================================================== */
(function () {
  var TAG = 'cart-quantity-selector-component';

  function num(v) {
    var n = parseInt(v, 10);
    return isFinite(n) ? n : null;
  }

  function recFor(el) {
    var stock = num(el.getAttribute('data-rn-stock'));
    if (stock !== null) {
      return {
        stock: Math.max(0, stock),
        remaining: num(el.getAttribute('data-rn-po-remaining')) || 0,
        poLine: el.hasAttribute('data-rn-po-line')
      };
    }
    var id = el.getAttribute('data-variant-id');
    var r = (window.RN_CART_STOCK && window.RN_CART_STOCK[id]) || null;
    if (!r && window.RN_NOTIFY && Array.isArray(window.RN_NOTIFY.variants)) {
      window.RN_NOTIFY.variants.forEach(function (v) { if (String(v.id) === String(id)) r = v; });
    }
    if (!r) return null;
    /* untracked = none on the shelf; with no allocation either, nothing to cap */
    var untracked = r.stock === null || r.stock === undefined;
    if (untracked && !(r.preorderRemaining > 0)) return null;
    /* no per-line flag from these sources: treat as one pooled line, as before */
    return { stock: untracked ? 0 : Math.max(0, r.stock), remaining: r.preorderRemaining || 0, poLine: null };
  }

  function inputOf(el) { return el.querySelector('input[type="number"]'); }
  function savedQty(el) {
    var inp = inputOf(el);
    return inp ? (num(inp.getAttribute('value')) || 0) : 0;
  }

  /* {cap, total, stock, others, poLine} for this line, or null = uncapped */
  function capFor(el) {
    var rec = recFor(el);
    if (!rec) return null;
    var id = el.getAttribute('data-variant-id');
    var othersAll = 0, othersShelf = 0, othersPo = 0, poSibling = false;
    Array.prototype.slice.call(document.querySelectorAll(TAG + '[data-variant-id="' + id + '"]')).forEach(function (o) {
      if (o === el) return;
      /* the drawer and the cart page can both be in the DOM; count one cart only */
      var scope = el.closest('cart-items-component');
      if (scope && !scope.contains(o)) return;
      var q = savedQty(o);
      othersAll += q;
      if (o.hasAttribute('data-rn-po-line')) { othersPo += q; poSibling = true; }
      else othersShelf += q;
    });
    var total = rec.stock + rec.remaining;
    /* A line WITHOUT the pre-order date is only "the in-stock half" when the
       same variant also has a pre-order line -- i.e. the buy box split a
       mixed order. A plain line on its own (a Bundle and save add-on, which
       goes in without pre-order fields, or anything added elsewhere) has no
       other half: it is pooled, stock + allocation. Capping it at the shelf
       alone refused an add-on with 0 in stock and plenty incoming. */
    var poLine = rec.poLine === false && !poSibling ? null : rec.poLine;
    /* Each half against its own pool: the pre-order line against the
       shipment allocation only, the in-stock line against the shelf only.
       A pooled line gets the combined total. */
    var cap = poLine === true ? rec.remaining - othersPo
      : poLine === false ? rec.stock - othersShelf
      : total - othersAll;
    return { cap: Math.max(0, cap), total: total, stock: rec.stock, others: othersAll, poLine: poLine };
  }

  function phrase(c) {
    if (c.poLine === false) {
      if (c.cap <= 0) return 'No more in stock — the rest of the stock is already on another line in your cart.';
      return 'Only ' + c.cap + ' in stock for this line. Lower the quantity to ' + c.cap +
        ' or fewer; to order more, add them as a pre-order from the product page.';
    }
    if (c.poLine === true) {
      if (c.cap <= 0) return 'No more available on the pre-order shipment.';
      return 'Only ' + c.cap + ' available on the pre-order shipment for this product. Lower the quantity to ' +
        c.cap + ' or fewer.';
    }
    if (c.cap <= 0) return 'No more available — the rest of this item is already on another line in your cart.';
    if (c.others > 0) {
      return 'Only ' + c.cap + ' available for this line (' + c.others +
        ' already on another line). Lower the quantity to ' + c.cap + ' or fewer.';
    }
    return 'Only ' + c.cap + ' available. Lower the quantity to ' + c.cap + ' or fewer.';
  }

  /* ---- error state ------------------------------------------------------- */
  (function style() {
    try {
      var s = document.createElement('style');
      s.textContent =
        TAG + '.rn-qty-err{border-color:#C62828!important;box-shadow:0 0 0 1px #C62828!important}' +
        '.cart-items__error.rn-qty-err-row .cart-item__error-text{color:#9B1C1C}';
      document.head.appendChild(s);
    } catch (e) {}
  })();

  function errBox(el) {
    var inp = inputOf(el);
    var line = inp && inp.getAttribute('data-cart-line');
    var row = el.closest('tr') || el.closest('[ref^="cartItemRows"]');
    if (!line || !row) return null;
    return row.querySelector('[ref="cartItemErrorContainer-' + line + '"]');
  }

  function setErr(el, text) {
    el.classList.add('rn-qty-err');
    var inp = inputOf(el);
    if (inp) inp.setAttribute('aria-invalid', 'true');
    var box = errBox(el);
    if (box) {
      var t = box.querySelector('.cart-item__error-text');
      if (t) t.textContent = text;
      box.classList.remove('hidden');
      box.classList.add('rn-qty-err-row');
    }
    syncCheckout();
  }

  function clearErr(el) {
    if (!el.classList.contains('rn-qty-err')) return;
    el.classList.remove('rn-qty-err');
    var inp = inputOf(el);
    if (inp) inp.removeAttribute('aria-invalid');
    var box = errBox(el);
    if (box && box.classList.contains('rn-qty-err-row')) {
      box.classList.remove('rn-qty-err-row');
      box.classList.add('hidden');
      var t = box.querySelector('.cart-item__error-text');
      if (t) t.textContent = '';
    }
    syncCheckout();
  }

  /* Checkout would submit the SAVED quantities, not the red one on screen, so
     it waits until every line is valid. Only buttons this file disabled are
     re-enabled. */
  function syncCheckout() {
    var anyErr = !!document.querySelector(TAG + '.rn-qty-err');
    Array.prototype.slice.call(document.querySelectorAll('[name="checkout"]')).forEach(function (b) {
      if (anyErr && !b.disabled) { b.disabled = true; b.setAttribute('data-rn-qty-blocked', ''); }
      else if (!anyErr && b.hasAttribute('data-rn-qty-blocked')) { b.disabled = false; b.removeAttribute('data-rn-qty-blocked'); }
    });
  }

  /* true = over the cap (error shown), false = fine (error cleared) */
  function check(el, qty) {
    var c = capFor(el);
    if (!c || qty === null || qty <= c.cap) { clearErr(el); return false; }
    setErr(el, phrase(c));
    return true;
  }

  /* ---- the stepper's max, so + stops at the cap ---------------------------
     Only the attribute; updateConstraints() would also clamp the value. */
  function applyCaps() {
    Array.prototype.slice.call(document.querySelectorAll(TAG)).forEach(function (el) {
      var c = capFor(el);
      var inp = inputOf(el);
      if (!c || !inp) return;
      inp.max = String(Math.max(c.cap, num(inp.min) || 1));
      if (typeof el.updateButtonStates === 'function') el.updateButtonStates();
    });
  }

  /* ---- keep what was typed ------------------------------------------------
     The component clamps an over-max number on blur and then sends it to the
     cart. Patched on the CART component's prototype (not the PDP's, which is
     its parent class), so every line -- including ones the drawer re-renders
     later -- gets it: over the cap, the number stays, the error shows, and no
     update is sent. Anything else goes through the component's own handling. */
  customElements.whenDefined(TAG).then(function () {
    var C = customElements.get(TAG);
    if (!C || C.prototype.__rnQty) return;
    var orig = C.prototype.setQuantity;
    C.prototype.setQuantity = function (event) {
      var n = num(event && event.target && event.target.value);
      if (check(this, n)) { if (event && event.preventDefault) event.preventDefault(); return; }
      return orig.apply(this, arguments);
    };
    C.prototype.__rnQty = true;
    applyCaps();
  });

  /* Live, on every keystroke, so the error shows while typing. */
  document.addEventListener('input', function (e) {
    var el = e.target && e.target.closest && e.target.closest(TAG);
    if (!el) return;
    check(el, num(e.target.value));
  });

  /* − / + set the value from script (no 'input' event), so re-check on the
     component's own update event too -- that is what clears the error when −
     brings a red number back under the cap. */
  document.addEventListener('quantity-selector:update', function (e) {
    var el = e.target && e.target.closest && e.target.closest(TAG);
    if (!el) return;
    var q = e.detail && typeof e.detail.quantity === 'number' ? e.detail.quantity : num(inputOf(el) && inputOf(el).value);
    check(el, q);
  });

  /* Enter in the field would submit the cart form with the red number. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target && e.target.closest && e.target.closest(TAG);
    if (el && el.classList.contains('rn-qty-err')) e.preventDefault();
  }, true);

  applyCaps();
  document.addEventListener('cart:update', function () { setTimeout(function () { applyCaps(); syncCheckout(); }, 120); });
  document.addEventListener('cart:refresh', function () { setTimeout(applyCaps, 120); });
  document.addEventListener('shopify:section:load', function () { setTimeout(applyCaps, 120); });
  /* The drawer re-renders its lines after each change and fires none of the
     above reliably, so watch for new selectors appearing. */
  try {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; applyCaps(); syncCheckout(); }, 60);
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
